import CompanyHotWalletsTableView from './companyHotWalletsTableView';

export default CompanyHotWalletsTableView;
